import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Risk } from '@/hooks';
import { Text, Title } from '@/components/Typography';
import { riskColors, riskLevels } from '@/utils/riskRange';
import { ResultCard, RiskCard, HighestRpn, RpnCard, DescriptionCard } from './styles';

interface FinalResultsProps {
	worstScore: number;
	worstValues: Risk[];
}

export function FinalResults({ worstScore: digitManipulated, worstValues }: FinalResultsProps) {
	return (
		<Row gutter={[0, 40]}>
			<Col span={24}>
				<Title level={5}>Sum of RPNs</Title>
				<ResultCard>{digitManipulated}</ResultCard>
			</Col>
			<Col span={24}>
				<Title level={5}>Higher RPNs</Title>
				<Row gutter={[0, 10]}>
					{worstValues.map(({ id, description, risk_scale, score }) => (
						<Col key={id} span={23}>
							<HighestRpn>
								<RiskCard xs={4} xxl={3} $cardColor={riskColors[risk_scale]}>
									{I18n.get(riskLevels[risk_scale])}
								</RiskCard>
								<RpnCard xs={4} xxl={3}>
									<Text strong>RPN</Text>
									{': '}
									{score}
								</RpnCard>
								<DescriptionCard xs={16} xxl={18}>
									<Text strong>Found at:</Text>
									{I18n.get(`${description}`)}
								</DescriptionCard>
							</HighestRpn>
						</Col>
					))}
				</Row>
			</Col>
		</Row>
	);
}
